const GoogleLoginButton = () => {
  const handleLogin = () => {
    const GOOGLE_AUTH_URL = `${process.env.REACT_APP_GOOGLE_AUTH_URL}?client_id=${process.env.REACT_APP_GOOGLE_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_GOOGLE_REDIRECT_URI}&response_type=code&scope=openid%20email%20profile&prompt=select_account`;

    window.location.href = GOOGLE_AUTH_URL;
  };

  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        handleLogin();
      }}
      className="mt-3 flex justify-center w-full items-center gap-2 px-4 py-1 border border-gray-300 rounded-md bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 shadow-sm hover:shadow-md transition-all duration-150"
    >
      <span className="w-8 h-8" aria-hidden>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 150 150"
          className="w-full h-full"
        >
          <path
            fill="#4285F4"
            d="M120,76.1c0-3.1-0.3-6.3-0.8-9.3H75.9v17.7h24.8c-1,5.7-4.3,10.7-9.2,13.9l14.8,11.5C115,101.8,120,90,120,76.1Z"
          />
          <path
            fill="#34A853"
            d="M75.9,120.9c12.4,0,22.8-4.1,30.4-11.1L91.5,98.4c-4.1,2.8-9.4,4.4-15.6,4.4c-12,0-22.1-8.1-25.8-18.9L34.9,95.6C42.7,111.1,58.5,120.9,75.9,120.9Z"
          />
          <path
            fill="#FBBC05"
            d="M50.1,83.8c-1.9-5.7-1.9-11.9,0-17.6L34.9,54.4c-6.5,13-6.5,28.3,0,41.2L50.1,83.8Z"
          />
          <path
            fill="#EA4335"
            d="M75.9,47.3c6.5-0.1,12.9,2.4,17.6,6.9L106.6,41C98.3,33.2,87.3,29,75.9,29.1c-17.4,0-33.2,9.8-41,25.3l15.2,11.8C53.8,55.3,63.9,47.3,75.9,47.3Z"
          />
        </svg>
      </span>
      <span>Đăng nhập với Google</span>
    </button>
  );
};

export default GoogleLoginButton;
